import BreadCrumb from "Common/BreadCrumb";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Flatpickr from "react-flatpickr";
import { ImagePlus, Search } from "lucide-react";
import dummyImg from "assets/images/users/user-dummy-img.jpg";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import Modal from "Common/Components/Modal";
import DeleteModal from "Common/DeleteModal";
import { useDispatch } from "react-redux";

import { useFormik } from "formik";
import * as Yup from "yup";

import { ToastContainer } from "react-toastify";
import {
  addEmployee as onAddEmployee,
  deleteEmployee as onDeleteEmployee,
  getEmployee as onGetEmployee,
  updateEmployee as onUpdateEmployee,
} from "slices/thunk";
// import { NotesData as dataList } from "Common/data";

interface TableData {
  serial: number;
  name: string;
  value?: string;
  link?: boolean;
}

const dataList: TableData[] = [
  { serial: 1, name: "RADIO" },
  { serial: 2, name: "LOTTERY" },
  { serial: 3, name: "TRIVIA" },
];

const GameCategory = () => {
  const dispatch = useDispatch<any>();

  const [data, setData] = useState<any>([]);
  const [eventData, setEventData] = useState<any>();

  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  // Image
  const [selectedImage, setSelectedImage] = useState<any>();

  const handleImageChange = (event: any) => {
    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        validation.setFieldValue("img", e.target.result);
        setSelectedImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Get Data
  useEffect(() => {
    dispatch(onGetEmployee());
  }, [dispatch]);

  useEffect(() => {
    setData(dataList);
  }, [dataList]);

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data

  const handleDelete = () => {
    if (eventData) {
      dispatch(onDeleteEmployee(eventData.id));
      setDeleteModal(false);
    }
  };
  //

  // Update Data

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      employeeId: (eventData && eventData.employeeId) || "",
      name: (eventData && eventData.name) || "",
      img: (eventData && eventData.img) || "",
      designation: (eventData && eventData.designation) || "",
      email: (eventData && eventData.email) || "",
      phone: (eventData && eventData.phone) || "",
      location: (eventData && eventData.location) || "",
      experience: (eventData && eventData.experience) || "",
      joinDate: (eventData && eventData.joinDate) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name"),
      img: Yup.string().required("Please Add Image"),
      designation: Yup.string().required("Please Enter Designation"),
      email: Yup.string().required("Please Enter Email"),
      phone: Yup.string().required("Please Enter Phone"),
      location: Yup.string().required("Please Enter Location"),
      experience: Yup.string().required("Please Enter Experience"),
      joinDate: Yup.string().required("Please Enter Date"),
    }),

    onSubmit: (values) => {
      if (isEdit) {
        const updateData = {
          id: eventData ? eventData.id : 0,
          ...values,
        };
        // update user
        dispatch(onUpdateEmployee(updateData));
      } else {
        const newData = {
          ...values,
          id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(),
          employeeId:
            "#TWE1001" +
            (Math.floor(Math.random() * (30 - 20)) + 20).toString(),
          experience: values.experience + " year",
        };
        // save new user
        dispatch(onAddEmployee(newData));
      }
      toggle();
    },
  });

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      setSelectedImage("");
    } else {
      setShow(true);
      setEventData("");
      setSelectedImage("");
      validation.resetForm();
    }
  }, [show, validation]);

  // columns
  const columns = useMemo(
    () => [
      {
        header: "S/N",
        accessorKey: "serial",
        enableColumnFilter: false,
      },
      {
        header: "Game Category",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link to="#!" className="flex items-center gap-3">
            <h6 className="grow">{cell.getValue()}</h6>
          </Link>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb title="Game Categories" pageTitle="Dashboard" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer closeButton={false} limit={1} />
      <div className="card" id="employeeTable">
        <div className="card-body">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">Game Categories</h6>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns || []}
              data={data || []}
              customPageSize={7}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <div className="noresult">
              <div className="py-6 text-center">
                <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                <p className="mb-0 text-slate-500 dark:text-zink-200">
                  We've searched more than 299+ Employee We did not find any
                  Employee for you search.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Employee Modal */}
      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">
            {!!isEdit ? "Edit Game" : "Add Game"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <input type="hidden" value="" name="id" id="id" />
            <input type="hidden" value="add" name="action" id="action" />
            <input type="hidden" id="id-field" />
            <div
              id="alert-error-msg"
              className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
            ></div>
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-12">
                <div className="relative size-24 mx-auto mb-4 rounded-full shadow-md bg-slate-100 profile-user dark:bg-zink-500">
                  <img
                    src={selectedImage || validation.values.img || dummyImg}
                    alt=""
                    className="object-cover w-full h-full rounded-full user-profile-image"
                  />
                  <div className="absolute bottom-0 flex items-center justify-center size-8 rounded-full ltr:right-0 rtl:left-0 profile-photo-edit">
                    <input
                      id="profile-img-file-input"
                      name="profile-img-file-input"
                      type="file"
                      accept="image/*"
                      className="hidden profile-img-file-input"
                      onChange={handleImageChange}
                    />
                    <label
                      htmlFor="profile-img-file-input"
                      className="flex items-center justify-center size-8 bg-white rounded-full shadow-lg cursor-pointer dark:bg-zink-600 profile-photo-edit"
                    >
                      <ImagePlus className="size-4 text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500" />
                    </label>
                  </div>
                </div>
                {validation.touched.img && validation.errors.img ? (
                  <p className="text-red-400">{validation.errors.img}</p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <label
                  htmlFor="employeeId"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Game ID
                </label>
                <input
                  type="text"
                  id="employeeId"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  value={validation.values.employeeId || "#TWE1001557"}
                  disabled
                />
              </div>
              <div className="xl:col-span-12">
                <label
                  htmlFor="gameTitleInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Game Title
                </label>
                <input
                  type="text"
                  id="gameTitleInput"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Enter title"
                  name="title"
                  onChange={validation.handleChange}
                  value={validation.values.title || ""}
                />
                {validation.touched.title && validation.errors.title ? (
                  <p className="text-red-400">{validation.errors.title}</p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <label
                  htmlFor="gameTypeSelect"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Game Type
                </label>
                <select
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  data-choices
                  data-choices-search-false
                  id="gameTypeSelect"
                  name="type"
                  onChange={validation.handleChange}
                  value={validation.values.type || ""}
                >
                  <option disabled={true}>Choose an option</option>
                  <option value="MERCHANT">MERCHANT</option>
                  <option value="RADIO">RADIO</option>
                </select>
                {validation.touched.type && validation.errors.type ? (
                  <p className="text-red-400">{validation.errors.type}</p>
                ) : null}
              </div>

              <div className="xl:col-span-12">
                <label
                  htmlFor="gameTypeSelect"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Choose Merchant
                </label>
                <select
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  data-choices
                  data-choices-search-true
                  id="gameTypeSelect"
                  name="type"
                  onChange={validation.handleChange}
                  value={validation.values.type || ""}
                >
                  <option disabled={true}>Choose an option</option>
                  <option value="MERCHANT">MERCHANT</option>
                  <option value="RADIO">RADIO</option>
                </select>
                {validation.touched.type && validation.errors.type ? (
                  <p className="text-red-400">{validation.errors.type}</p>
                ) : null}
              </div>

              <div className="xl:col-span-12">
                <label
                  htmlFor="gamePriceInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Price
                </label>
                <input
                  type="number"
                  id="gamePriceInput"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="5000"
                  name="price"
                  onChange={validation.handleChange}
                  value={validation.values.price || ""}
                />
                {validation.touched.price && validation.errors.price ? (
                  <p className="text-red-400">{validation.errors.price}</p>
                ) : null}
              </div>

              <div className="xl:col-span-12">
                <label
                  htmlFor="gameDescriptionInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Description
                </label>
                <textarea
                  id="gameDescriptionInput"
                  rows={6}
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Long Description"
                  name="description"
                  onChange={validation.handleChange}
                  value={validation.values.description || ""}
                />
                {validation.touched.description &&
                validation.errors.description ? (
                  <p className="text-red-400">
                    {validation.errors.description}
                  </p>
                ) : null}
              </div>

              <div className="xl:col-span-6">
                <label
                  htmlFor="gameDrawTimeInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Draw Time
                </label>
                <Flatpickr
                  id="joiningDateInput"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  options={{
                    dateFormat: "d M, Y",
                  }}
                  placeholder="Select time"
                  name="drawTime"
                  onChange={(date: any) =>
                    validation.setFieldValue(
                      "drawTime",
                      moment(date[0]).format("DD MMMM ,YYYY")
                    )
                  }
                  value={validation.values.drawTime || ""}
                />
                {validation.touched.drawTime && validation.errors.drawTime ? (
                  <p className="text-red-400">{validation.errors.drawTime}</p>
                ) : null}
              </div>
              <div className="xl:col-span-6">
                <label
                  htmlFor="gameLinkInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Game Link
                </label>
                <input
                  type="text"
                  id="gameLinkInput"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="listen on ..."
                  name="link"
                  onChange={validation.handleChange}
                  value={validation.values.link || ""}
                />
                {validation.touched.link && validation.errors.link ? (
                  <p className="text-red-400">{validation.errors.link}</p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <label
                  htmlFor="gameStatusSelect"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Choose Status
                </label>
                <select
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  data-choices
                  data-choices-search-true
                  id="gameStatusSelect"
                  name="status"
                  onChange={validation.handleChange}
                  value={validation.values.status || ""}
                >
                  <option value="">Choose an option</option>
                  <option value="ENABLED">ENABLED</option>
                  <option value="DISABLED">DISABLED</option>
                </select>
                {validation.touched.status && validation.errors.status ? (
                  <p className="text-red-400">{validation.errors.status}</p>
                ) : null}
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="reset"
                id="close-modal"
                data-modal-close="addEmployeeModal"
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                id="addNew"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {!!isEdit ? "Update" : "Add Game"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default GameCategory;
